import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Linkedin, Instagram } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();


  const socialLinks = [
    // { icon: Github, href: 'https://github.com/aiec-iitm', label: 'GitHub' },
    // { icon: Twitter, href: 'https://twitter.com/aiec_iitm', label: 'Twitter' },
    { icon: Linkedin, href: 'https://www.linkedin.com/company/aiec-iitm-janakpuri-ai-experience-centre/posts/?feedView=all', label: 'LinkedIn' },
    { icon: Instagram, href: 'https://instagram.com/ai_ec_iitm', label: 'Instagram' }
  ];

  const quickLinks = [
    { name: 'About Us', href: '#about' },
    { name: 'Events', href: '#events' },
    { name: 'Projects', href: '#projects' },
    { name: 'Careers', href: '/careers' },
    { name: 'Contact', href: '#contact' }
  ];

  const contactInfo = [
    // { icon: Mail, text: 'contact@aiec.iitm.ac.in' },
    // { icon: Phone, text: '+91 98765 43210' },
    { icon: MapPin, text: 'D-29, Institutional Area, Janakpuri, New Delhi-110058' }
  ];

  return (
    <footer className="footer">
      {/* Aura stream flow background */}
      <div className="footer-gradient-bg" aria-hidden="true">
        <div className="footer-stream-band s1" />
        <div className="footer-stream-band s2" />
        <div className="footer-stream-band s3" />
        <div className="footer-stream-band s4" />
        <div className="footer-stream-band s5" />
      </div>
      <div className="container">
        <div className="footer-content">
          {/* Logo and Description */}
          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="footer-logo">
              <img
                src="/logo.png"
                alt="AIEC IITM logo"
                className="logo-icon"
              />
              <span className="logo-text">AIEC IITM</span>
            </div>
            <p className="footer-description">
              The premier AI and technical society at IITM Janakpuri,
              bridging human intelligence with artificial intelligence through
              innovation, collaboration, and cutting-edge technology.
            </p>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <social.icon className="social-icon" />
                </motion.a>
              ))}
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              {quickLinks.map((link, index) => (
                <motion.li
                  key={link.name}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.4, delay: 0.2 + index * 0.05 }}
                  viewport={{ once: true }}
                >
                  <a href={link.href} className="footer-link">
                    {link.name}
                  </a>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3 className="footer-title">Contact Us</h3>
            <div className="contact-info">
              {contactInfo.map((contact, index) => (
                <motion.div
                  key={index}
                  className="contact-item"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.4, delay: 0.3 + index * 0.05 }}
                  viewport={{ once: true }}
                >
                  <contact.icon className="contact-icon" />
                  <span className="contact-text">{contact.text}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>

        {/* Footer Bottom */}
        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="footer-divider"></div>
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} AIEC IITM. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <a href="/privacy" className="footer-bottom-link">Privacy Policy</a>
              <a href="/terms" className="footer-bottom-link">Terms of Service</a>
            </div>
          </div>


        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
